import { truckingRateConstants } from '../../_constants';

export function truckingRates(state = {}, action) {
    switch (action.type) {
        case truckingRateConstants.TRUCKING_RATE_FETCHING:
            return {
                ...state,
                truckingRateFetching: true
            };
        case truckingRateConstants.TRUCKING_RATE_FETCHED:
            return {
                ...state,
                truckingRateFetching: false
            };
        case truckingRateConstants.GET_ALL_TRUCKING_RATES:
            return {
                ...state,
                truckingRates: action.truckingRates
            };
        case truckingRateConstants.GET_TRUCKING_RATES:
            return {
                ...state,
                truckingRates: action.truckingRates
            };
        case truckingRateConstants.GET_TRUCKING_RATE_BY_ID:
            return {
                ...state,
                truckingRate: action.truckingRate
            };
        case truckingRateConstants.UPDATE_TRUCKING_RATE:
            return {
                ...state,
                updating: true
            };
        case truckingRateConstants.SEARCH_TRUCKING_RATES:
            return {
                ...state,
                truckingRates: action.truckingRates
            };
        case truckingRateConstants.TRUCKINGRATE_GROUP_BY_CHARGE:
            return {
                ...state,
                truckingRateCharges: action.truckingRateCharges
            };
        case truckingRateConstants.TRUCKINGRATE_GROUP_CHARGE:
            return {
                ...state,
                truckingRateGroupCharge: action.truckingRateGroupCharge
            };
        case truckingRateConstants.TRUCKINGRATE_GROUP_BRANCH_CHARGE:
            return {
                ...state,
                truckingRates: action.truckingRates
            };
        default:
            return state;
    }
}